module.exports = __webpack_public_path__ + "static/media/flu.42686d08.jpg";